import { Field, Form, FormikProps } from 'formik';
import { FormValues } from './types';
import styles from './ReportModal.module.css';
import LocationField from '../Forms/Fields/Location';
import CustomerField from './Customer';
import { FormikRadioGroupInput } from '../Forms/Components/RadioGroup';
import { FormikDateRangePicker } from '../Forms/Components/DateRangePicker';

type ReportFormProps = FormikProps<FormValues> & {
	id: string;
};

export default function CSREfficiencyForm({ id }: ReportFormProps) {
	return (
		<Form
			className={styles['report-form']}
			id={id}
		>
			<div className={styles['flex-row']}>
				<div>
					<Field
						name='reportDateRange'
						component={FormikDateRangePicker}
						label='Date Range'
						className={styles['date-range-input']}
					/>
				</div>
				<div>
					<label>Customer:</label>
					<CustomerField
						fieldName='customer'
						buttonClassName={styles['customer-dropdown']}
					/>
				</div>
			</div>
			<div className={styles['flex-row']}>
				<div>
					<label>Pickup Location:</label>
					<LocationField
						fieldName='pickupLocation'
						className={styles['prepull-location-dropdown']}
						selectionOnly={true}
					/>
				</div>
				<div>
					<label>Deliver Location:</label>
					<LocationField
						fieldName='deliverLocation'
						className={styles['prepull-location-dropdown']}
						selectionOnly={true}
					/>
				</div>
			</div>
			<div className={styles['flex-row']}>
				<div>
					<div className={styles['flex-row']}>
						<Field
							component={FormikRadioGroupInput}
							name='reportStyle'
							label='Report Style:'
							labelPlacement='top'
							defaultOptionSelected='User Detail'
							radioItems={['User Detail', 'User Summary']}
						/>
					</div>
				</div>
				<div>
					<div className={styles['flex-row']}>
						<Field
							component={FormikRadioGroupInput}
							name='accept'
							label='Report Format:'
							labelPlacement='top'
							defaultOptionSelected='HTML'
							radioItems={['HTML', 'Excel']}
						/>
					</div>
				</div>
			</div>
		</Form>
	);
}
